import { CalendarBlank, MapPin } from "@phosphor-icons/react";
import { Stack, Text } from "flicket-ui";
import { INormalisedData } from "~features/nonseated-reservation/nonseated-reservation.types";

export const PrechargeBanner = ({ data }: { data: INormalisedData }) => {
  return (
    <Stack gap={5} direction="vertical" alignItems={"center"}>
      <Stack gap={2} direction="vertical" alignItems={"center"}>
        <Text variant="header.L">
          Best available price found for {data.name}
        </Text>
        <Stack gap={"6/4"}>
          <Text variant="regular">
            <Stack alignItems={"center"} gap={"3/4"}>
              <CalendarBlank />
              {data.displayDate}
            </Stack>
          </Text>
          <Text variant="regular">
            <Stack alignItems={"center"} gap={"3/4"}>
              <MapPin />
              {data.location}
            </Stack>
          </Text>
        </Stack>
      </Stack>
      <Stack
        borderRadius={"md"}
        boxShadow={"0px 2px 24px 0px rgba(0, 0, 0, 0.15)" as any}
        direction={"vertical"}
        gap={2}
        padding={3}
        alignItems="center"
        maxWidth={"800px"}
      >
        <Text variant="header.M">Lock it in now, pay later!</Text>
        <Text variant="regular" textAlign={"center"}>
          This price is only available for a limited time. Once you begin
          checkout, it’s locked in – your card will only be charged when presale
          opens. You can cancel anytime before then.
        </Text>
      </Stack>
    </Stack>
  );
};
